module.exports = __webpack_public_path__ + "img/general_staff_annual_check_up.b5992ea6.png";